
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 66 62","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33 15c-8.837 0-16 7.163-16 16a16 16 0 0016 16c8.835 0 16-7.163 16-16s-7.165-16-16-16zm1.494 5.776c1.56 0 2.018.905 2.018 1.94 0 1.292-1.033 2.487-2.798 2.487-1.477 0-2.18-.742-2.136-1.97 0-1.035.865-2.457 2.916-2.457zm-3.996 19.806c-1.067 0-1.845-.648-1.1-3.49l1.221-5.041c.212-.807.247-1.13 0-1.13-.318 0-1.703.556-2.52 1.106l-.531-.871c2.591-2.165 5.571-3.435 6.846-3.435 1.067 0 1.243 1.26.712 3.2l-1.4 5.3c-.248.936-.142 1.26.107 1.26.32 0 1.366-.387 2.396-1.199l.603.81c-2.521 2.52-5.27 3.49-6.334 3.49z"}})])
          )
        }
      }
    